'use client'

import React from 'react'
import { WagamourV2Modal } from '@/components/v2/WagamourV2Modal'
import { WagamourV2ModalEyebrow, WagamourV2ModalStoryLine } from '@/components/v2/WagamourV2ModalContent'

export type DevPreviewPlayIntegratedUpdatesSheetProps = {
  isOpen: boolean
  count: number
  onClose: () => void
}

export function DevPreviewPlayIntegratedUpdatesSheet({
  isOpen,
  count,
  onClose,
}: DevPreviewPlayIntegratedUpdatesSheetProps) {
  return (
    <WagamourV2Modal isOpen={isOpen} onClose={onClose} title="Updates">
      <WagamourV2ModalEyebrow>Operational events</WagamourV2ModalEyebrow>
      <WagamourV2ModalStoryLine
        label="Unread count"
        value={`${count} local Play activity event${count === 1 ? '' : 's'}`}
      />
      <p className="mt-3 text-sm text-white/70">
        Main surface shows count only. Events come from real PlayActivityEvent rows when seeded.
      </p>
    </WagamourV2Modal>
  )
}
